import React, {useEffect} from 'react'
import StatisticsService from "services/StatisticsService";
import Workspace from "components/Workspace";
import CorrespondenceSection from "./sections/CorrespondenceSection";
import DemandService from "services/DemandService";
import PrivilegeService from "services/PrivilegeService";

function CorrespondencePanel(
    {
        match
    }) {

    const demandId = match.params.id;

    useEffect(() => {
        StatisticsService.getCurrentRound(demandId)
        DemandService.getBuyerPrivileges(demandId);
        return () => {
            StatisticsService.clearCurrentRound();
            PrivilegeService.cleanupPrivileges(PrivilegeService.DEMAND_PRIVILEGE_STORE_KEY);
        }
        // eslint-disable-next-line
    }, []);


    return (
        <>
            <Workspace
                render={<>
                    <CorrespondenceSection />
                </>}
            />
        </>
    )
}


export default CorrespondencePanel;